import OrderByHeader from './OrderByHeader.js'
import Fragment from './Fragment.js'
import Row from './Row.js'
import RowHeading from './RowHeading.js'

import './styles.scss'

export default {
    fragment: Fragment,
    row: Row,
    rowHeading: RowHeading,
    orderByHeader: OrderByHeader,
}
